'use client';

import { ServiceModalityE } from '@/types/cyclone/models';
import classNames from 'classnames';
import { Building2, Video } from 'lucide-react';

interface ServiceModalityProps {
  value: ServiceModalityE | null;
  onChange: (value: ServiceModalityE) => void;
  isSetup?: boolean;
}

export default function ServiceModality({ value, onChange, isSetup }: ServiceModalityProps) {
  return (
    <div className="flex flex-col gap-6">
      <div className={classNames('space-y-1', { 'px-4 sm:px-0': !isSetup, 'self-center': isSetup })}>
        <h2 className="text-2xl font-medium text-gray-900">
          {isSetup ? 'Agrega tu primer servicio' : 'Modalidad del servicio'}
        </h2>
        <p className="text-[#626262] text-sm">Indica si este servicio será presencial u online</p>
      </div>

      <div className={classNames('space-y-4', { 'px-4 sm:px-0': !isSetup })}>
        <div
          className={`border-2 rounded-xl p-4 sm:p-5 cursor-pointer transition-all duration-200 ${
            value === ServiceModalityE.LOCAL
              ? 'border-blue bg-blue/10'
              : 'border-gray-200 hover:border-blue/30'
          }`}
          onClick={() => onChange(ServiceModalityE.LOCAL)}
        >
          <div className="flex flex-col sm:flex-row sm:items-start gap-3 sm:gap-4">
            <div className="flex items-center gap-3 sm:mt-1 sm:gap-4">
              <input
                type="radio"
                name="modality"
                checked={value === ServiceModalityE.LOCAL}
                className="radio radio-sm border-gray-400 checked:border-blue"
              />
              <Building2 className="h-5 w-5 text-blue flex-shrink-0" />
            </div>
            <div className="flex-1 space-y-2">
              <span className="font-medium text-xl text-gray-900 block">Servicio presencial</span>
              <p className="text-[#626262] text-sm leading-relaxed">
                El cliente debe asistir físicamente a tu negocio o a la ubicación donde se brinda el servicio.
              </p>
            </div>
          </div>
        </div>

        <div
          className={`border-2 rounded-xl p-4 sm:p-5 cursor-pointer transition-all duration-200 ${
            value === ServiceModalityE.VIRTUAL
              ? 'border-blue bg-blue/10'
              : 'border-gray-200 hover:border-blue/30'
          }`}
          onClick={() => onChange(ServiceModalityE.VIRTUAL)}
        >
          <div className="flex flex-col sm:flex-row sm:items-start gap-3 sm:gap-4">
            <div className="flex items-center gap-3 sm:mt-1 sm:gap-4">
              <input
                type="radio"
                name="modality"
                checked={value === ServiceModalityE.VIRTUAL}
                className="radio radio-sm border-gray-400 checked:border-blue"
              />
              <Video className="h-5 w-5 text-blue flex-shrink-0" />
            </div>
            <div className="flex-1 space-y-2">
              <span className="font-medium text-xl text-gray-900 block">Servicio online</span>
              <p className="text-[#626262] text-sm leading-relaxed">
                El servicio se brinda de forma remota a través de videollamada u otra plataforma online.
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
